export const MATH_WORKSPACE_PRINT_LAYOUT = 'math_workspace';

/** Purposes de desarrollo OA 20 / matemática que piden operatoria, no redacción. */
export const MATH_CALCULATION_PURPOSES = new Set(['conversion_inquiry']);

/** Único bloque narrativo de cierre en guías OA 20. */
export const MATH_REFLECTION_PURPOSES = new Set(['closure_reflect', 'procedure_reflect']);

/** Tablas de medición — nunca plantilla de encuesta/votos. */
export const MEASUREMENT_TABLE_PURPOSES = new Set(['measurement_table', 'equivalence_table']);

const NARRATIVE_PROMPT_RE =
  /multiplicar o dividir|explica con tus palabras|justifica|redacta|describe el procedimiento/i;
const CALCULATION_PROMPT_RE =
  /operatoria|convierte|transforma.*unidad|muestra tu c[aá]lculo|espacio de (?:trabajo|c[aá]lculo)/i;

export function resolveBlockBlueprintPurpose(
  block: { _blueprintPurpose?: string } | undefined,
  payload: Record<string, unknown> = {},
): string {
  return String(block?._blueprintPurpose || payload.blueprintPurpose || '').trim();
}

export function resolveDesarrolloPrintLayout(
  block: { _blueprintPurpose?: string } | undefined,
  payload: Record<string, unknown> = {},
): 'math_workspace' | 'writing_lines' {
  const purpose = resolveBlockBlueprintPurpose(block, payload);
  const prompt = String(payload.prompt || payload.title || '');

  if (payload.printLayout === MATH_WORKSPACE_PRINT_LAYOUT) return 'math_workspace';
  if (MATH_CALCULATION_PURPOSES.has(purpose)) return 'math_workspace';
  if (MATH_REFLECTION_PURPOSES.has(purpose) || NARRATIVE_PROMPT_RE.test(prompt)) {
    return 'writing_lines';
  }
  if (CALCULATION_PROMPT_RE.test(prompt)) return 'math_workspace';
  return 'writing_lines';
}

export function resolveDesarrolloWritingLineCount(purpose: string): number {
  if (purpose === 'survey_reflect' || MATH_REFLECTION_PURPOSES.has(purpose)) return 5;
  return 4;
}
